	/**
	 * ScrollTo
	 * Copyright (c) 2007-2014 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
	 * Licensed under MIT
	 * @author Ariel Flesler
	 * @version 1.4.12
	 */
	// ;(function(a){if(typeof define==='function'&&define.amd){define(['jquery'],a)}else{a(jQuery)}}(function($){var j=$.scrollTo=function(a,b,c){return $(window).scrollTo(a,b,c)};j.defaults={axis:'xy',duration:parseFloat($.fn.jquery)>=1.3?0:1,limit:true};j.window=function(a){return $(window)._scrollable()};$.fn._scrollable=function(){return this.map(function(){var a=this,isWin=!a.nodeName||$.inArray(a.nodeName.toLowerCase(),['iframe','#document','html','body'])!=-1;if(!isWin)return a;var b=(a.contentWindow||a).document||a.ownerDocument||a;return/webkit/i.test(navigator.userAgent)||b.compatMode=='BackCompat'?b.body:b.documentElement})};$.fn.scrollTo=function(f,g,h){if(typeof g=='object'){h=g;g=0}if(typeof h=='function')h={onAfter:h};if(f=='max')f=9e9;h=$.extend({},j.defaults,h);g=g||h.duration;h.queue=h.queue&&h.axis.length>1;if(h.queue)g/=2;h.offset=both(h.offset);h.over=both(h.over);return this._scrollable().each(function(){if(f==null)return;var d=this,$elem=$(d),targ=f,toff,attr={},win=$elem.is('html,body');switch(typeof targ){case'number':case'string':if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)){targ=both(targ);break}targ=win?$(targ):$(targ,this);if(!targ.length)return;case'object':if(targ.is||targ.style)toff=(targ=$(targ)).offset()}var e=$.isFunction(h.offset)&&h.offset(d,targ)||h.offset;$.each(h.axis.split(''),function(i,a){var b=a=='x'?'Left':'Top',pos=b.toLowerCase(),key='scroll'+b,old=d[key],max=j.max(d,a);if(toff){attr[key]=toff[pos]+(win?0:old-$elem.offset()[pos]);if(h.margin){attr[key]-=parseInt(targ.css('margin'+b))||0;attr[key]-=parseInt(targ.css('border'+b+'Width'))||0}attr[key]+=e[pos]||0;if(h.over[pos])attr[key]+=targ[a=='x'?'width':'height']()*h.over[pos]}else{var c=targ[pos];attr[key]=c.slice&&c.slice(-1)=='%'?parseFloat(c)/100*max:c}if(h.limit&&/^\d+$/.test(attr[key]))attr[key]=attr[key]<=0?0:Math.min(attr[key],max);if(!i&&h.queue){if(old!=attr[key])animate(h.onAfterFirst);delete attr[key]}});animate(h.onAfter);function animate(a){$elem.animate(attr,g,h.easing,a&&function(){a.call(this,targ,h)})}}).end()};j.max=function(a,b){var c=b=='x'?'Width':'Height',scroll='scroll'+c;if(!$(a).is('html,body'))return a[scroll]-$(a)[c.toLowerCase()]();var d='client'+c,html=a.ownerDocument.documentElement,body=a.ownerDocument.body;return Math.max(html[scroll],body[scroll])-Math.min(html[d],body[d])};function both(a){return $.isFunction(a)||typeof a=='object'?a:{top:a,left:a}};return j}));

	/**
	 * LocalScroll
	 * Copyright (c) 2007-2014 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
	 * Licensed under MIT
	 * @author Ariel Flesler
	 * @version 1.3.5
	 */
	// ;(function(a){if(typeof define==='function'&&define.amd){define(['jquery'],a)}else{a(jQuery)}}(function($){var g=location.href.replace(/#.*/,'');var h=$.localScroll=function(a){$('body').localScroll(a)};h.defaults={duration:1000,axis:'y',event:'click',stop:true,target:window};$.fn.localScroll=function(a){a=$.extend({},h.defaults,a);if(a.hash&&location.hash){if(a.target)window.scrollTo(0,0);scroll(0,location,a)}return a.lazy?this.on(a.event,'a,area',function(e){if(filter.call(this)){scroll(e,this,a)}}):this.find('a,area').filter(filter).bind(a.event,function(e){scroll(e,this,a)}).end().end();function filter(){return!!this.href&&!!this.hash&&this.href.replace(this.hash,'')==g&&(!a.filter||$(this).is(a.filter))}};h.hash=function(){};function scroll(e,a,b){var c=a.hash.slice(1),elem=document.getElementById(c)||document.getElementsByName(c)[0];if(!elem)return;if(e)e.preventDefault();var d=$(b.target);if(b.lock&&d.is(':animated')||b.onBefore&&b.onBefore(e,elem,d)===false)return;if(b.stop)d._scrollable().stop(true);if(b.hash){var f=elem.id===c?'id':'name',$a=$('<a> </a>').attr(f,c).css({position:'absolute',top:$(window).scrollTop(),left:$(window).scrollLeft()});elem[f]='';$('body').prepend($a);location.hash=a.hash;$a.remove();elem[f]=c}d.scrollTo(elem,b).trigger('notify.serialScroll',[elem])};return h}));

	// Generated by CoffeeScript 1.6.2
	/*
	jQuery Waypoints - v2.0.4
	Copyright (c) 2011-2014 Caleb Troughton
	Dual licensed under the MIT license and GPL license.
	https://github.com/imakewebthings/jquery-waypoints/blob/master/licenses.txt
	*/
	// (function(){var t=[].indexOf||function(t){for(var e=0,n=this.length;e<n;e++){if(e in this&&this[e]===t)return e}return-1},e=[].slice;(function(t,e){if(typeof define==="function"&&define.amd){return define("waypoints",["jquery"],function(n){return e(n,t)})}else{return e(t.jQuery,t)}})(this,function(n,r){var i,o,l,s,f,u,c,a,h,d,p,y,v,w,g,m;i=n(r);a=t.call(r,"ontouchstart")>=0;s={horizontal:{},vertical:{}};f=1;c={};u="waypoints-context-id";p="resize.waypoints";y="scroll.waypoints";v=1;w="waypoints-waypoint-ids";g="waypoint";m="waypoints";o=function(){function t(t){var e=this;this.$element=t;this.element=t[0];this.didResize=false;this.didScroll=false;this.id="context"+f++;this.oldScroll={x:t.scrollLeft(),y:t.scrollTop()};this.waypoints={horizontal:{},vertical:{}};this.element[u]=this.id;c[this.id]=this;t.bind(y,function(){var t;if(!(e.didScroll||a)){e.didScroll=true;t=function(){e.doScroll();return e.didScroll=false};return r.setTimeout(t,n[m].settings.scrollThrottle)}});t.bind(p,function(){var t;if(!e.didResize){e.didResize=true;t=function(){n[m]("refresh");return e.didResize=false};return r.setTimeout(t,n[m].settings.resizeThrottle)}})}t.prototype.doScroll=function(){var t,e=this;t={horizontal:{newScroll:this.$element.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.$element.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};if(a&&(!t.vertical.oldScroll||!t.vertical.newScroll)){n[m]("refresh")}n.each(t,function(t,r){var i,o,l;l=[];o=r.newScroll>r.oldScroll;i=o?r.forward:r.backward;n.each(e.waypoints[t],function(t,e){var n,i;if(r.oldScroll<(n=e.offset)&&n<=r.newScroll){return l.push(e)}else if(r.newScroll<(i=e.offset)&&i<=r.oldScroll){return l.push(e)}});l.sort(function(t,e){return t.offset-e.offset});if(!o){l.reverse()}return n.each(l,function(t,e){if(e.options.continuous||t===l.length-1){return e.trigger([i])}})});return this.oldScroll={x:t.horizontal.newScroll,y:t.vertical.newScroll}};t.prototype.refresh=function(){var t,e,r,i=this;r=n.isWindow(this.element);e=this.$element.offset();this.doScroll();t={horizontal:{contextOffset:r?0:e.left,contextScroll:r?0:this.oldScroll.x,contextDimension:this.$element.width(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:r?0:e.top,contextScroll:r?0:this.oldScroll.y,contextDimension:r?n[m]("viewportHeight"):this.$element.height(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};return n.each(t,function(t,e){return n.each(i.waypoints[t],function(t,r){var i,o,l,s,f;i=r.options.offset;l=r.offset;o=n.isWindow(r.element)?0:r.$element.offset()[e.offsetProp];if(n.isFunction(i)){i=i.apply(r.element)}else if(typeof i==="string"){i=parseFloat(i);if(r.options.offset.indexOf("%")>-1){i=Math.ceil(e.contextDimension*i/100)}}r.offset=o-e.contextOffset+e.contextScroll-i;if(r.options.onlyOnScroll&&l!=null||!r.enabled){return}if(l!==null&&l<(s=e.oldScroll)&&s<=r.offset){return r.trigger([e.backward])}else if(l!==null&&l>(f=e.oldScroll)&&f>=r.offset){return r.trigger([e.forward])}else if(l===null&&e.oldScroll>=r.offset){return r.trigger([e.forward])}})})};t.prototype.checkEmpty=function(){if(n.isEmptyObject(this.waypoints.horizontal)&&n.isEmptyObject(this.waypoints.vertical)){this.$element.unbind([p,y].join(" "));return delete c[this.id]}};return t}();l=function(){function t(t,e,r){var i,o;r=n.extend({},n.fn[g].defaults,r);if(r.offset==="bottom-in-view"){r.offset=function(){var t;t=n[m]("viewportHeight");if(!n.isWindow(e.element)){t=e.$element.height()}return t-n(this).outerHeight()}}this.$element=t;this.element=t[0];this.axis=r.horizontal?"horizontal":"vertical";this.callback=r.handler;this.context=e;this.enabled=r.enabled;this.id="waypoints"+v++;this.offset=null;this.options=r;e.waypoints[this.axis][this.id]=this;s[this.axis][this.id]=this;i=(o=this.element[w])!=null?o:[];i.push(this.id);this.element[w]=i}t.prototype.trigger=function(t){if(!this.enabled){return}if(this.callback!=null){this.callback.apply(this.element,t)}if(this.options.triggerOnce){return this.destroy()}};t.prototype.disable=function(){return this.enabled=false};t.prototype.enable=function(){this.context.refresh();return this.enabled=true};t.prototype.destroy=function(){delete s[this.axis][this.id];delete this.context.waypoints[this.axis][this.id];return this.context.checkEmpty()};t.getWaypointsByElement=function(t){var e,r;r=t[w];if(!r){return[]}e=n.extend({},s.horizontal,s.vertical);return n.map(r,function(t){return e[t]})};return t}();d={init:function(t,e){var r;if(e==null){e={}}if((r=e.handler)==null){e.handler=t}this.each(function(){var t,r,i,s;t=n(this);i=(s=e.context)!=null?s:n.fn[g].defaults.context;if(!n.isWindow(i)){i=t.closest(i)}i=n(i);r=c[i[0][u]];if(!r){r=new o(i)}return new l(t,r,e)});n[m]("refresh");return this},disable:function(){return d._invoke.call(this,"disable")},enable:function(){return d._invoke.call(this,"enable")},destroy:function(){return d._invoke.call(this,"destroy")},prev:function(t,e){return d._traverse.call(this,t,e,function(t,e,n){if(e>0){return t.push(n[e-1])}})},next:function(t,e){return d._traverse.call(this,t,e,function(t,e,n){if(e<n.length-1){return t.push(n[e+1])}})},_traverse:function(t,e,i){var o,l;if(t==null){t="vertical"}if(e==null){e=r}l=h.aggregate(e);o=[];this.each(function(){var e;e=n.inArray(this,l[t]);return i(o,e,l[t])});return this.pushStack(o)},_invoke:function(t){this.each(function(){var e;e=l.getWaypointsByElement(this);return n.each(e,function(e,n){n[t]();return true})});return this}};n.fn[g]=function(){var t,r;r=arguments[0],t=2<=arguments.length?e.call(arguments,1):[];if(d[r]){return d[r].apply(this,t)}else if(n.isFunction(r)){return d.init.apply(this,arguments)}else if(n.isPlainObject(r)){return d.init.apply(this,[null,r])}else if(!r){return n.error("jQuery Waypoints needs a callback function or handler option.")}else{return n.error("The "+r+" method does not exist in jQuery Waypoints.")}};n.fn[g].defaults={context:r,continuous:true,enabled:true,horizontal:false,offset:0,triggerOnce:false};h={refresh:function(){return n.each(c,function(t,e){return e.refresh()})},viewportHeight:function(){var t;return(t=r.innerHeight)!=null?t:i.height()},aggregate:function(t){var e,r,i;e=s;if(t){e=(i=c[n(t)[0][u]])!=null?i.waypoints:void 0}if(!e){return[]}r={horizontal:[],vertical:[]};n.each(r,function(t,i){n.each(e[t],function(t,e){return i.push(e)});i.sort(function(t,e){return t.offset-e.offset});r[t]=n.map(i,function(t){return t.element});return r[t]=n.unique(r[t])});return r},above:function(t){if(t==null){t=r}return h._filter(t,"vertical",function(t,e){return e.offset<=t.oldScroll.y})},below:function(t){if(t==null){t=r}return h._filter(t,"vertical",function(t,e){return e.offset>t.oldScroll.y})},left:function(t){if(t==null){t=r}return h._filter(t,"horizontal",function(t,e){return e.offset<=t.oldScroll.x})},right:function(t){if(t==null){t=r}return h._filter(t,"horizontal",function(t,e){return e.offset>t.oldScroll.x})},enable:function(){return h._invoke("enable")},disable:function(){return h._invoke("disable")},destroy:function(){return h._invoke("destroy")},extendFn:function(t,e){return d[t]=e},_invoke:function(t){var e;e=n.extend({},s.vertical,s.horizontal);return n.each(e,function(e,n){n[t]();return true})},_filter:function(t,e,r){var i,o;i=c[n(t)[0][u]];if(!i){return[]}o=[];n.each(i.waypoints[e],function(t,e){if(r(i,e)){return o.push(e)}});o.sort(function(t,e){return t.offset-e.offset});return n.map(o,function(t){return t.element})}};n[m]=function(){var t,n;n=arguments[0],t=2<=arguments.length?e.call(arguments,1):[];if(h[n]){return h[n].apply(null,t)}else{return h.aggregate.call(null,n)}};n[m].settings={resizeThrottle:100,scrollThrottle:30};return i.load(function(){return n[m]("refresh")})})}).call(this);

	//
	// Start Theme JS
	// ------------------------------------------
	// Add "loaded" class when a section has been loaded
	// $(window).scroll(function() { 
	// 	var scrollTop = $(window).scrollTop();
	// 	$(".section").each(function() {
	//   		var elementTop = $(this).offset().top - $('#header').outerHeight();
	//   		if(scrollTop >= elementTop) {
	//     		$(this).addClass('loaded');
	//   		}
	// 	});
    //});

/**
 * =======================================
 * Function: Detect Mobile Device
 * =======================================
 */
// source: http://www.abeautifulsite.net/detecting-mobile-devices-with-javascript/
var isMobile = {
	Android: function() {
		return navigator.userAgent.match( /Android/i );
	},
	BlackBerry: function() {
		return navigator.userAgent.match( /BlackBerry/i );
	},
	iOS: function() {
		return navigator.userAgent.match( /iPhone|iPad|iPod/i );
	},
	Opera: function() {
		return navigator.userAgent.match( /Opera Mini/i );
	},
	Windows: function() {
		return navigator.userAgent.match( /IEMobile/i );
	},
	any: function() {
		return ( isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows() );
	},
};     

(function($) {
	// Sticky Navbar Affix
	$('#navbar').affix({
		offset: {
	  		top: $('#topbar').outerHeight(),
		}
	});

	$('.nav a:not(".dropdown-toggle")').on('click', function(){
		if($('.navbar-toggle').css('display') !='none'){
			$(".navbar-toggle").click();
		}
	}); 

  	//
	// Custom Scripts
	// ----------------------------------------
	$.localScroll({
		offset: 1 - $('#navbar').outerHeight(),
		duration: 750,
		hash: true,
		easing: "swing",
		filter: ":not(.carousel-control)",

		onAfter: function(target, event) {
			$("a.active").removeClass("active").parents(".dropdown").find(".dropdown-toggle").removeClass("active");
			$("a[href=#"+target.attr("id")+"]").addClass("active").parents(".dropdown").find(".dropdown-toggle").addClass("active");
		}
	});

	// $("section").waypoint(function(direction) { 
	// 	$("a.active").removeClass("active").parents(".dropdown").find(".dropdown-toggle").removeClass("active");
	// 	$("a[href=#"+$(this).attr("id")+"]").addClass("active").parents(".dropdown").find(".dropdown-toggle").addClass("active");
	// }, { offset: $('#navbar').outerHeight() + 1 }); 

	// Contact Form
	$form = $('#contactform');
	$form.on("submit", function(){

		var action = $(this).attr('action'),
			$message = $("#message"),
			$submit = $("#submit"),
			$submitLoader = $('#submit-loader');

		$message.collapse('hide').html('');
 		$submit.attr('disabled','disabled');
 		$submitLoader.fadeIn(200);

		$.post(action, $form.serialize())
			.fail(function(data) {
				$submit.removeAttr('disabled');
				$message.addClass('bg-danger text-danger');
				for (var i in data.responseJSON) {
					$message.append("<p>" + data.responseJSON[i][0] + "</p>");
				}
			})
			.done(function(data) { // success
				$message.removeClass('bg-danger text-danger');
				$message.addClass('bg-success text-success');
				$message.html('<p>' + data.responseText + '</p>');
				$("#submit").html("Envoyé!");

				// Event snippet for Page vue conversion page
				if (typeof gtag === 'function') {
					gtag('event', 'conversion', {'send_to': 'AW-980659939/GkxYCOyFtcoZEOPdztMD'});
				}
			})
			.always(function(data) {
				if ($message.hasClass('collapsing')) {
					$message.on('hidden.bs.collapse', function() {
						$message.collapse('show');
					});
				}
				else {
					$message.collapse('show');
				}
				$submitLoader.fadeOut(200);
			});

		$('html,body').animate({
	      scrollTop: $message.top
	    }, 1000);

		return false;
	});

  	// Carousel Swipe & key control
 //  	$(".carousel").swiperight(function() {  
 //  		$(this).carousel('prev');  
	// });
	// $(".carousel").swipeleft(function() {  
 //  		$(this).carousel('next');  
	// });

	$(document).on("keydown", function(e) { 
	  	switch (e.keyCode) {
	  		case 37: $(".carousel:visible").carousel("prev"); break;
	  		case 39: $(".carousel:visible").carousel("next"); break;
	  	}
	});

	// Magific Popup
	$(".youtube-popup").magnificPopup({
		type: "iframe",

		iframe: {
		markup: '<div class="mfp-iframe-scaler">'+
		        '<div class="mfp-close"></div>'+
		        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
		        '<div class="mfp-title">Some caption</div>'+
		    '</div>'
		},
		callbacks: {
			markupParse: function(template, values, item) {
				values.title = item.el.attr('title');
			}
		}
	});

	$('.media-group-places').magnificPopup({
		delegate: 'a.group', // child items selector, by clicking on it popup will open
		type: 'image',
		gallery: { 'enabled': true },

		image: {
			titleSrc: "data-original-title"
		}
	});

	$('.media-group-medias').magnificPopup({
		delegate: 'a.group', // child items selector, by clicking on it popup will open
		type: 'image',
		gallery: { 'enabled': true },
		image: {
			titleSrc: "data-original-title"
		},
		callbacks: {
			open: function() {
				this.content.swipeleft(function(e) { $.magnificPopup.instance.next(); });
				this.content.swiperight(function(e) { $.magnificPopup.instance.prev(); });
			}
		}
	});

	$(".gmap-link").magnificPopup({
		type: "iframe",
		
		iframe: {
			patterns: {
				gmap_embed: {
					index: "www.google.fr/maps",
					id: function(url) { return $.magnificPopup.instance.st.el.attr("data-query"); },
					src: "https://www.google.com/maps/embed/v1/place?key=AIzaSyA8TX4lV8WzsGdyjIJczSjNOls32Nsh3rQ&q=%id%"
				}
			}
		}
	});

  	// Tooltips
  	$("abbr").tooltip();
  	$(".fa-question-circle").tooltip();
  	$("a[title]:not(.no-tooltip):not(.tooltip-top):not(.carousel-control)").tooltip({ "placement": "bottom" });
  	$("a.tooltip-top").tooltip({ "placement": "top" });

	// FastClick
	//FastClick.attach(document.body);

	// More button
	// $(".collapse").on("show.bs.collapse hide.bs.collapse", function() {
	// 	var $fa = $(this).siblings(".btn").find(".fa");

	// 	$fa.addClass('fa-spin');

	// 	$(this).on("shown.bs.collapse hidden.bs.collapse", function() {
	// 		$fa.removeClass("fa-spin");
	// 	});

	// 	if ( $fa.hasClass("fa-plus") ) {
	// 		$fa.removeClass("fa-plus").addClass("fa-minus");
	// 	}
	// 	else {
	// 		$fa.removeClass("fa-minus").addClass("fa-plus");
	// 	}
	// });

	// Fee Counter
	var $feeSpan = $('#fee'),
		feeAnim = new CountUp("fee", 0, $feeSpan.html(), 0, 1),
		feeWp = new Waypoint({
			element: document.getElementById("fee"),
			handler: function(direction) {
				feeAnim.start();
			},
			offset: '90%'
		});

	// Fee Form
	$('#fee-form input').on('change', function(e) {
		// Option handling.
		// if ($('#adults').is(":checked")) {
		// 	$("input").attr("disabled", false);
		// 	$("label[for='combat'] span").html("Sportive + Défense");
		// 	$("label[data-original-title]").removeAttr("title").tooltip("destroy");
		// }
		// else {
		// 	$("[name='option']:not('#combat, #choice')").attr("disabled", true)
		// 		.siblings('label').attr("title", "Non disponible pour cette tranche d'âge.").tooltip();
		// 	if ($("input:checked").is(":disabled")) {
		// 		$("#combat").prop("checked", true);
		// 	}
		// }
		var age = $("input[name='age']:checked").attr("id");
		$("#fee-form input[data-ages]").each(function() {
			var isInAgeRange = $(this).attr('data-ages').indexOf(age) >= 0;
			$(this).prop("disabled", !isInAgeRange);
			if (!isInAgeRange) {
				if ($(this).is(":disabled"))
					$(this).siblings("label").attr("title", "non disponible pour cette tranche d'âge").tooltip();
				if ($(this).is(":checked"))
					$(this).prop("checked", false);
			}
			else {
				$(this).siblings("label").removeAttr("title").tooltip("destroy");
			}

			// auto select custom formula
			var $choice = $("#choice");
			if ($("#fee-form input[data-ages]:checked").length === 0) {
				$choice.prop("checked", true);
			}
			if ($("#choice").is(":checked") && $("input.sport:checked").length === 0) {
				$("#empty-sports").removeClass("hidden");
			}
			else {
				$("#empty-sports").addClass("hidden");
			}
		});
		
		$("[data-kids-label]").each(function() {
			$(this).html($(this).attr("data-" + age + "-label"));
		});

		// Sports Choice. 
		if ($(this).is("[type='checkbox']")) {
			$("#choice").prop("checked", true);
		}

		$.post('/fee', $("#fee-form").serialize())
			.done(function(data) {
				console.log(data);
				if (data.fee % 1 === 0) {
					feeAnim.update(data.fee);
				}
				else $(".fee-wrapper").html(data.fee).css("font-size", "2em");
				// console.debug(data);
			});
	});

	// Table Header affixed.
	var $thead = $("thead:first"),
		$trLast = $("tr.last");
	if (!isMobile) {
		$thead.affix({
			offset: {
				top: $thead.offset().top - 75,
				bottom: function() {
					return (this.bottom = $(document).height() - $trLast.offset().top)
				}
			}
		});
	}

	// Schedule Filters
	$(".lessons-filter").on("change", function() {
		if ($(this).is(":checked"))
			$("." + $(this).attr("value")).removeClass("transparant");
		else $("." + $(this).attr("value")).addClass("transparant");
	});
})(jQuery);

/* Google Map */
function initializeGoogleMaps() {
	var	mapOptions = {
			draggable: !isMobile.any(),
			panControl: !isMobile.any(),
			mapTypeControl: false,
			streetViewControl: false,
			scrollwheel: false,
			styles: [
				{ elementType: "geometry", stylers: [{ color: "#242f3e" }] },
				{ elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
				{ elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
				{
					featureType: "administrative.locality",
					elementType: "labels.text.fill",
					stylers: [{ color: "#d59563" }],
				},
				{
					featureType: "poi",
					elementType: "labels.text.fill",
					stylers: [{ color: "#d59563" }],
				},
				{
					featureType: "poi.park",
					elementType: "geometry",
					stylers: [{ color: "#263c3f" }],
				},
				{
					featureType: "poi.park",
					elementType: "labels.text.fill",
					stylers: [{ color: "#6b9a76" }],
				},
				{
					featureType: "road",
					elementType: "geometry",
					stylers: [{ color: "#38414e" }],
				},
				{
					featureType: "road",
					elementType: "geometry.stroke",
					stylers: [{ color: "#212a37" }],
				},
				{
					featureType: "road",
					elementType: "labels.text.fill",
					stylers: [{ color: "#9ca5b3" }],
				},
				{
					featureType: "road.highway",
					elementType: "geometry",
					stylers: [{ color: "#746855" }],
				},
				{
					featureType: "road.highway",
					elementType: "geometry.stroke",
					stylers: [{ color: "#1f2835" }],
				},
				{
					featureType: "road.highway",
					elementType: "labels.text.fill",
					stylers: [{ color: "#f3d19c" }],
				},
				{
					featureType: "transit",
					elementType: "geometry",
					stylers: [{ color: "#2f3948" }],
				},
				{
					featureType: "transit.station",
					elementType: "labels.text.fill",
					stylers: [{ color: "#d59563" }],
				},
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [{ color: "#17263c" }],
				},
				{
					featureType: "water",
					elementType: "labels.text.fill",
					stylers: [{ color: "#515c6d" }],
				},
				{
					featureType: "water",
					elementType: "labels.text.stroke",
					stylers: [{ color: "#17263c" }],
				},
				{ 
					"stylers": [
						{ "saturation": -90 }
					]
				}
			]
		};

	var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions),
		img = new google.maps.MarkerImage('/images/map-marker.png', null, null, null, new google.maps.Size(32, 32)),
		br = new google.maps.Marker({
			position: new google.maps.LatLng(43.607434, 7.124780),
			map: map,
			icon: img,
			optimized: 0 // Force retina size.
		});
		
	var ne = new google.maps.LatLng(43.610395, 7.133838),
		sw = new google.maps.LatLng(43.607751, 7.066357);
	var bounds = new google.maps.LatLngBounds(sw, ne);
	map.fitBounds(bounds);

	iw = new google.maps.InfoWindow({
		content: '<p class="infowindow"><strong>Boxing Squad Antibes</strong><br>101-103 bld Beau Rivage Prolongé<br>06600 Antibes</p>'
	});
	google.maps.event.addListener(br, 'click', function() {
		iw.open(map, br);
	});

	if ($(window).width() >= 768) {
		iw.open(map, br);
	}
}

$(window).on("load", function() {
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&' + 'callback=initializeGoogleMaps&key=AIzaSyCPrjXSoZIuPLve6e0Kya9wTVYue9TEYyA';
	document.body.appendChild(script);
});

// Facebook Like
(function(doc, script) {
  var js, 
      fjs = doc.getElementsByTagName(script)[0],
      frag = doc.createDocumentFragment(),
      add = function(url, id) {
          if (doc.getElementById(id)) {return;}
          js = doc.createElement(script);
          js.src = url;
          id && (js.id = id);
          frag.appendChild( js );
      };
      
    // Google+ button
    // add('https://apis.google.com/js/plusone.js');
    // Facebook SDK
    add('//connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v2.4&appId=756109957799039', 'facebook-jssdk');
    // Twitter SDK
    // add('//platform.twitter.com/widgets.js');

    fjs.parentNode.insertBefore(frag, fjs);
}(document, 'script'));